import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import EditObjectiveTrackerForm from "./EditObjectiveTrackerForm";
import ObjectivesTrackerEditTriggerButton from "../detail/ObjectivesTrackerEditTriggerButton";

const EditObjectiveTrackerDialog = ({
  onSubmitHandler,
  tracker,
  externalOpen,
  hiddenClassName = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const onSubmit = (formValues) => {
    setIsOpen(false);
    onSubmitHandler(formValues);
  };

  useEffect(() => {
    setIsOpen(externalOpen?.externalOpen);
  }, [externalOpen]);

  return (
    <DialogFormPanel
      trigger={
        <ObjectivesTrackerEditTriggerButton className={hiddenClassName} />
      }
      title={t("objectivesTracker.editForm.title")}
      description={t("objectivesTracker.editForm.description", {
        name: tracker?.name,
      })}
      content={
        <EditObjectiveTrackerForm
          onSubmitHandler={onSubmit}
          tracker={tracker}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default EditObjectiveTrackerDialog;
